import posthog from "posthog-js";
import { POST_HOG_KEY } from "./config.json";

const initializePostHog = () => {
  const postHogKey = localStorage.getItem("postHogKey") || POST_HOG_KEY;

  posthog.init(postHogKey, {
    api_host: "https://us.i.posthog.com",
    defaults: "2025-11-30",
    // defaults: "2026-05-30",
    cookieless_mode: "always",
    capture_pageview: true,
    capture_pageleave: false,
    autocapture: false,
    disable_session_recording: true,
    // Never create identified person profiles
    person_profiles: "never",
  });
};

const killPostHog = () => {
  // Stop replay if it was enabled in the authenticated app.
  posthog.stopSessionRecording();
  posthog.reset(true);
};

export { initializePostHog, killPostHog };
